import ApiService from "../../POS/services/apiService";
import { CURRENCY } from "../selecters";
const initialState = {
  currency: {
    name: "",
    price: 1
  }
};

const CurrencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURRENCY:
      return {
        ...state,
        currency: action.payload,
      };
    default:
      return state;
  }
};

export default CurrencyReducer;